export default __webpack_public_path__ + "static/media/Circus_04.7d8dd08c.png";